import React from 'react';

import { makeStyles, Typography, Toolbar } from '@gogame/components';

import { useIsMaintenance } from './index';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    background: theme.palette.warning.light,
    padding: '7px 16px ',
    minHeight: 'auto',
  },
}));

export const MaintenanceToolbar = () => {
  const isMaintenance = useIsMaintenance();
  const classes = useStyles();
  return isMaintenance ? (
    <Toolbar className={classes.toolbar}>
      <Typography variant={'body2'}>
        We are updating GoGame. Some services may not work correctly, but it
        will only take a few minutes.
      </Typography>
    </Toolbar>
  ) : null;
};
export default MaintenanceToolbar;
